<template>
  <div class="jzbWrap user" style="display: inline-block;min-width:600px" v-loading="loading">
    <el-card style="display: inline-block;min-width:600px;margin-top:8px;">
      <el-form size="medium" :model="cashForm" :rules="rules" inline ref="cashForm" label-width="80px">
        <table>
          <tr>
            <th>子账户账号:</th>
            <td>{{cashForm.subAcctNo}}</td>
          </tr>
          <tr>
            <th>余额:</th>
            <td>{{cashForm.balance}}</td>
            <th>担保余额:</th>
            <td>{{cashForm.marginAmount}}
              <el-button type="text" style="background:#fff;color:#e95b5b;border:none;" size="mini" @click="queryPayShopDepositLog">查看</el-button>
            </td>
            <th>可提现余额:</th>
            <td>{{cashForm.encashAmount}}</td>
          </tr>
          <tr>
            <th>银行户名:</th>
            <td>{{cashForm.memberAcctName | desensitizationName}}</td>
            <th>银行卡号:</th>
            <td>{{cashForm.memberAcctNo | desensitizationBank}}</td>
          </tr>
        </table>
        <div style="position:relative">
          <el-form-item label="提现" prop="amount">
            <el-input v-model.trim="cashForm.amount" placeholder="请输入金额">
              <i slot="prefix" class="iconfont icon-qian" style="font-size:12px;"></i>
            </el-input>
            <span v-if="false" class="serviceCash">手续费：{{cashForm.fee}}</span>
            <span class="max-amount">(最高可提现金额：{{cashForm.encashAmount}}元)</span>
          </el-form-item>
          <!-- <div class="max-amount">(最高可提现金额：{{cashForm.encashAmount}}元)</div> -->
        </div>
        <div>

        <el-form-item label="手机号">
          <el-input :disabled="true" v-model.trim="cashForm.desensitizationPhone" placeholder="请输入手机号"></el-input>
          <el-button v-if="!showTimer" type="primary"  @click="sendCode" size="mini">{{sendCodeText}}</el-button>
          <el-button v-if="showTimer" type="primary" size="mini">{{timer}}s后重新发送</el-button>
        </el-form-item>
        </div>
        <div>

        <el-form-item label="验证码" prop="msgCode">
          <el-input placeholder="请输入验证码" v-model.trim="cashForm.msgCode"></el-input>
        </el-form-item>
        </div>

        <!-- <el-form-item>
          <el-button size="mini"  @click="submitForm('cashForm')">提现</el-button>
        </el-form-item> -->
      </el-form>
      <div class="cash-tip">
        <div>
          <span class="el-icon-warning"></span>
        </div>
        <div>
          <div>
            余额：指已结算金额减去已提现金额。
          </div>
          <div>
            可提现余额：当日已结算金额在次日10点后变成可提现余额。
          </div>
        </div>
      </div>
      <div class="submitBtnWrap">
          <el-button size="mini"  @click="submitForm('cashForm')">提现</el-button>
      </div>
    </el-card>

    <el-dialog
      title="信息认证"
      :modal-append-to-body="false"
      center
      :visible.sync="dialogVisible"
      top="250px"
      width="400px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="jzbWrap exportbtnbox">
        <div class="text-center">平安银行为加强商户安全信息管理，需要重新补充认证信息</div>
        <div style="color: #ff6224;margin-top: 10px;">步骤</div>
        <div style="color: #ff6224;">1.点击“立即认证”前往平安银行页面认证信息</div>
        <div style="color: #ff6224;">2.认证完成后点击“我已认证”</div>
        <div class="add-margin">
          <el-button type="text" class="" @click="getVipData" >已认证</el-button>
          <el-button type="primary" class="button-bg-color" @click="navToAuthenticationUrl" >去认证</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import {phone} from '@/utils/reg'
import {desensitization} from '@/utils/utils'
import {
  jzbCashCode,
  jzbCashFee,
  jzbCashInfo,
  jzbBankAdditionalRecorded,
  jzbSupplementaryUrl
} from '@/models/jzbModel'
export default {
  props: {
    type: {
      type: Number
    },
    hasNotice: {
      type: Boolean,
      default: false
    }
  },
  data () {
    var checkphone = (rule, value, callback) => {
      console.log(rule, 'rule')
      if (value) {
        if (!phone(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      } else {
        callback(new Error('请输入手机号'))
      }
    }
    return {
      loading: false, // 加载动画
      showTimer: false, // 显示计时
      sendCodeText: '发送验证码',
      timer: 120, // 验证码计时时间
      setTime: null, // 倒计时
      MessageOrderNo: '', // 返回的验证码回填字段
      tranNetMemberCode: '',
      corpId: '',   //  公司id
      userNickname: '',
      memberAcctName: '',
      cashForm: {
        subAcctNo: '', // 子账户账号
        balance: '', // 余额
        marginAmount: '', // 担保余额
        encashAmount: '', // 可提现余额
        memberAcctName: '', // 银行类型
        memberAcctNo: '', // 银行卡号
        amount: '', // 提现
        fee: '0', // 手续费
        mobile: '', // 手机号
        desensitizationPhone: '', // 脱敏 手机号
        msgCode: '' // 验证码
      },
      dialogVisible: false,
      authenticationUrl: '',

      rules: {
        amount: [
          { required: true, message: '请输入提现金额', trigger: 'blur' }
        ],
        mobile: [
          {validator: checkphone, trigger: 'blur'}
        ],
        msgCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        desc: [{ required: true, message: '请填写活动形式', trigger: 'blur' }]
      }
    }
  },
  filters: {
    desensitizationPhone (val) {
      return desensitization(val, 3, 4)
    },
    desensitizationCard (val) {
      return desensitization(val, 4, 4)
    },
    desensitizationName (val) {
      return desensitization(val, 1, 0)
    },
    desensitizationBank (val) {
      return desensitization(val, 4, 4)
    }

  },
  methods: {
    desensitization,
    /* 
      提交 提现
      2021 11 03 入参加corpId
    */
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.canGetCash()) {
            jzbCashFee({
              // 'FundSummaryAcctNo': '15000093383145',
              'tranNetMemberCode': this.tranNetMemberCode,
              'subAcctNo': this.cashForm.subAcctNo,
              'subAcctName': this.userNickname,
              'takeCashAcctNo': this.cashForm.memberAcctNo,
              'takeCashAcctName': this.memberAcctName,
              'ccy': 'RMB',
              'cashAmt': this.cashForm.amount,
              'takeCashCommission': '0.0',
              'messageOrderNo': this.MessageOrderNo,
              'messageCheckCode': this.cashForm.msgCode,
              'corpId': this.corpId
            })
              .then(res => {
                if (res.code === 200) {
                  this.sendCodeText = '发送验证码'
                  const h = this.$createElement
                  this.$msgbox({
                    message: h('p', null, [
                      h('span', { class: 'el-icon-success', style: 'color: #67c23a;font-size:20px;font-weight:600;' }, ''),
                      h('p', { style: 'font-size:14px;font-weight:600;padding:7px 0' }, '提现成功'),
                      h('p', { style: 'color: #ff6224;font-size:20px;font-weight:600;' }, this.cashForm.amount + '元')
                    ]),
                    showCancelButton: false,
                    confirmButtonText: '知道了',
                    showClose: false,
                    closeOnClickModal: false,
                    confirmButtonClass: 'confirm_btn_style',
                    center: true
                  })
                  this.cashForm.msgCode = ''
                  this.cashForm.amount = ''
                  clearInterval(this.setTime)
                  // this.timer = 0
                  this.showTimer = false
                  this.sendCodeText = '发送验证码'
                } else {
                  const h = this.$createElement
                  this.$msgbox({
                    message: h('p', null, [
                      h('span', { class: 'el-icon-error', style: 'color: #ff6224;font-size:20px;font-weight:600;' }, ''),
                      h('p', { style: 'font-size:20px;font-weight:600;padding:7px 0' }, '提现失败'),
                      h('p', { style: 'color: #ff6224;font-size:14px;font-weight:600;' }, res.msg)
                    ]),
                    showCancelButton: false,
                    confirmButtonText: '知道了',
                    showClose: false,
                    closeOnClickModal: false,
                    confirmButtonClass: 'confirm_btn_style',
                    center: true
                  })
                }
              })
          } else {
            this.$message({
              message: '可提现余额不够',
              type: 'warning'
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    // 提现金额是否大于可提现余额
    canGetCash () {
      if (this.cashForm.encashAmount) {
        if (parseInt(this.cashForm.encashAmount) >= parseInt(this.cashForm.amount)) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    // 发送验证码
    sendCode () {
      if (!this.cashForm.amount) {
        this.$message({
          message: '请输入提现金额',
          type: 'warning'
        })
      } else {
        if (this.canGetCash()) {
          jzbCashCode({
            // 'FundSummaryAcctNo': '',
            'tranNetMemberCode': this.tranNetMemberCode,
            'subAcctNo': this.cashForm.subAcctNo,
            'tranType': '1',
            'cashAmt': this.cashForm.amount
          }).then(res => {
            if (res.code === 200) {
              this.$message({
                message: '发送验证码成功',
                type: 'success'
              })
              this.MessageOrderNo = res.data.messageOrderNo
              this.showTimer = true
              this.setTime = setInterval(() => {
                this.timer = this.timer - 1
                if (this.timer <= 0) {
                  clearInterval(this.setTime)
                  this.timer = 120
                  this.showTimer = false
                  this.sendCodeText = '重新发送'
                }
              }, 1000)
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              })
            }
          })
        } else {
          this.$message({
            message: '可提现余额不够',
            type: 'warning'
          })
        }
      }
    },
    
    /* 
      获取用户信息  
      2021 11 03 出参加corpId
    */
    getVipData () {
      jzbCashInfo({
        'shopId': parseInt(localStorage.getItem('shop_id')),
        'objectType': this.type
      }).then(res => {
        if (res.code === 200) {
          let data = res.data[0]
          this.corpId = data.corpId
          this.tranNetMemberCode = data.tranNetMemberCode
          this.userNickname = data.userNickname
          this.memberAcctName = data.memberAcctName
          data.desensitizationPhone = desensitization(data.mobile, 3, 4)
          Object.assign(this.cashForm, data)
          this.loading = false
          if(data.status === 2){
            this.getRecorded()
          }
        } else {
          this.loading = false
        }
      })
      .catch(error => {
        console.log(error)
        this.loading = true
      })
    },
    queryPayShopDepositLog () {
      this.$router.push({
        path: '/user/queryPayShopDepositLog',
        query: {
          type: this.type
        }
      })
    },
    getRecorded(){
      jzbBankAdditionalRecorded(this.cashForm.subAcctNo).then((res) => {
        if(res.data.txnReturnCode === '000000'){
          this.dialogVisible = false
        }else{
          jzbSupplementaryUrl({subAcctNo: this.cashForm.subAcctNo, mobile: this.cashForm.mobile}).then((response) => {
            this.authenticationUrl = response.data
            this.dialogVisible = true
          })
        }
      })
    },
    navToAuthenticationUrl(){
      window.open(this.authenticationUrl,'','width=500,height=800');
    }
  },
  created () {
    if (!this.hasNotice) {
      this.loading = true

      this.getVipData()
    }
  }
}
</script>
<style lang="scss" scoped>
.user{
  min-height: 400px;
}
.user-info{
  color: #606266;
  font-size: 12px;
  .flex-item{
    display: flex;
    &-label{
      display: inline-block;
      width: 100px;
      text-align: right;
    }
    div{
      padding-right: 10px;
      padding-bottom: 15px;
    }
  }
}
.serviceCash{
  color: #606266;
  font-size: 12px;
  display: inline-block;
  padding-left: 15px;
}
table{
  color: #606266;
  font-size: 12px;
  vertical-align: middle;
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 10px;
  th,td{
    padding: 0;
    vertical-align: middle;
    line-height: 1.5;
    margin-bottom: 14px;
  }
  th{
    padding: 7px 10px;
    text-align: right;
    font-weight: 500;
    width: 84px;
    box-sizing: border-box;
  }
  td{
    padding:8px 7px 8px 0;
    text-align: left;
  }
}
.submitBtnWrap{
  text-align: center;
  margin-top: 20px;
}
.rgColor{
  color: #ff6224;
}
.cash-tip{
  display: flex;
  background:rgba(255,245,226,1);
  border-radius:2px;
  font-size:12px;
  font-family:PingFang-SC;
  font-weight:500;
  color:rgba(253,166,33,1);
  line-height: 1.5;
  padding: 10px 0;
  width: 400px;
  &>div:nth-child(1){
    width: 30px;
    text-align: center;
  }
  &>div:nth-child(2){
    width: 100%;
  }
}
.max-amount{
  font-size:12px;
  font-family:PingFang-SC;
  font-weight:500;
  color:rgba(255,98,36,1);
  line-height:1.5;
  padding-left: 5px;
  // position: absolute;
  // bottom:0;
  // right: 0;
}
.exportbtnbox {
  .el-button {
    padding: 10px;
    background: #fff;
    color: #606266;
    border: 1px solid #dcdfe6;
    position: relative;
    width: 100px;
    .inputfile {
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
      height: 100%;
      width: 100%;
    }
  }
  .el-button:hover {
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }
  .add-margin{
    margin-top: 20px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/userCash.vue